import { useEffect, useRef } from 'react';

/**
 * Returns value on previous render.
 * @param {*} value - value.
 * @returns {*} previous value.
 */

const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export default usePrevious;
